// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[data-v-36ce728a]:root {
  --vl-theme-primary-color: #ffe615;
  --vl-theme-primary-color-60: rgb(100%, 94.1176470588%, 44.9411764706%);
  --vl-theme-primary-color-70: rgb(100%, 93.137254902%, 35.7647058824%);
  --vl-theme-primary-color-rgba-30: rgba(255, 230, 21, 0.3);
  --vl-theme-fg-color: #333332;
  --vl-theme-fg-color-60: rgb(52%, 52%, 51.7647058824%);
  --vl-theme-fg-color-70: rgb(44%, 44%, 43.7254901961%);
}
.vl-vi[data-v-36ce728a]::before, .vl-vi[data-v-36ce728a]::after {
  font-family: "vlaanderen-icon" !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-style: normal;
  font-variant: normal;
  font-weight: normal;
  text-decoration: none;
  text-transform: none;
  display: inline-block;
  vertical-align: middle;
}
.vl-vi.vl-vi-u-180deg[data-v-36ce728a]::before {
  display: inline-block;
  transform: rotate(180deg);
  vertical-align: middle;
}
.vl-vi-u-xs[data-v-36ce728a]::before {
  font-size: 0.8rem;
}
.vl-vi-u-s[data-v-36ce728a]::before {
  font-size: 1.3rem;
}
.vl-vi-u-m[data-v-36ce728a]::before {
  font-size: 1.7rem;
}
.vl-vi-u-l[data-v-36ce728a]::before {
  font-size: 2rem;
}
.vl-vi-u-xl[data-v-36ce728a]::before {
  font-size: 2.2rem;
}
.vl-vi-u-90deg[data-v-36ce728a]::before {
  display: inline-block;
  transform: rotate(90deg);
}
.vl-vi-u-180deg[data-v-36ce728a]::before {
  display: inline-block;
  transform: rotate(180deg);
}
.mo-environment-header[data-v-36ce728a] {
  padding: 0px 10px;
  color: #fff;
  font-weight: 500;
}
.mo-environment-header.dev[data-v-36ce728a] {
  background-color: #05c;
}
.mo-environment-header.test[data-v-36ce728a] {
  background-color: orange;
}
.mo-environment-header.testat[data-v-36ce728a] {
  background-color: #ffec40;
}
.mo-environment-header.beta[data-v-36ce728a] {
  background-color: purple;
}
.mo-environment-header.stg[data-v-36ce728a] {
  background-color: mediumseagreen;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
